(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    

// =====================================================
  // MAPA DE COLORES — Actualizar cuando se agregue un color nuevo
  // Formato: 'ID_TAXONOMIA': ['Color1', 'Color2', ...]
  // Para encontrar el ID: filtrar por ese color en la colección
  // y copiar el número al final de la URL
  // =====================================================
  const COLOR_FILTER_MAP = {
    '1':  ['Sombra', 'Ámbar'],                              // Negro
    '2':  ['Agua', 'Eucalipto', 'Cielo', 'Reptilia Azul'],                               // Azul
    '3':  ['Nube', 'Vainilla', 'Vino-Vainilla'],                                // Blanco
    '4':  ['Sol'],                                             // Dorado
    '6':  ['Arena', 'Almendra', 'Vainilla', 'Macadamia'],      // Beige
    '7':  ['Avellana', 'Tierra', 'Reptilia', 'Macadamia', 'Ámbar', 'África', 'Piel natural', 'Tierra 2.0', 'Piel natural 2.0', 'Piel natural 3.0'],     // Marrón
    '9':  ['Selva', 'Pino', 'Pistacho', 'Limón', 'Eucalipto'], // Verde
    '10': ['Fuego'],                                           // Naranja
    '11': ['Rosa'],                                            // Rosa
    '13': ['Granada', 'Vino', 'Vino-Vainilla'],                                 // Rojo
    '14': ['Mantequilla'],                                     // Amarillo
     '5': ['Espejo'],                         // Plateado
  '2865': ['África', 'Ámbar', 'Reptilia Azul', 'Vino-Vainilla', 'Reptilia'],                         // Multicolor
    // Agregar aquí cuando haya productos con estos colores:
    // 'ID': ['NombreVariante'],                               // Color base
  };
  // =====================================================

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function applyVariantCard(item) {
    if (!item.dataset.variantId) return;

    const variantId = item.dataset.variantId;
    const variantImage = item.dataset.variantImage;
    const variantColor = item.dataset.variantColor;

    // Actualizar link con ?variant=ID
    const link = item.querySelector('a.product-card__link, a.product-grid__link');
    if (link && variantId) {
      const u = new URL(link.href);
      u.searchParams.set('variant', variantId);
      link.href = u.toString();
    }

    // Cambiar imagen y mover slideshow al slide correcto
    if (variantImage && variantColor) {
      const img = item.querySelector('.product-media-container img');
      if (img) {
        img.src = variantImage;
        img.srcset = variantImage;
      }

      const productCard = item.querySelector('product-card');
      const slideshow = productCard?.refs?.slideshow;
      if (slideshow) {
        const color = variantColor.toLowerCase();
        const slides = Array.from(slideshow.refs?.slides || []);
        const firstColorSlide = slides.find(function(slide) {
          const alt = (slide.querySelector('img')?.alt || '').toLowerCase().trim();
          return alt.includes(color);
        });
        if (firstColorSlide) {
          const slideId = firstColorSlide.getAttribute('slide-id');
          slideshow.select({ id: slideId }, undefined, { animate: false });
        }
      }
    }

    // Marcar el swatch correcto
    const inputs = item.querySelectorAll('input[type="radio"]');
    inputs.forEach(function(input) { input.checked = false; });
    const correctInput = item.querySelector(`input[data-variant-id="${variantId}"]`);
    if (correctInput) {
      correctInput.checked = true;
    } else if (variantColor) {
      const colorInput = item.querySelector(`input[value="${variantColor}"]`);
      if (colorInput) colorInput.checked = true;
    }

    // Badge de agotado por color
    const badgeContainer = item.querySelector('.product-badges');
    if (badgeContainer) {
      const isAvailable = item.dataset.colorAvailable === 'true';
      // Quitar todos los badges de agotado existentes (incluyendo el de Horizon)
      badgeContainer.querySelectorAll('.product-badges__badge').forEach(function(b) {
        if (b.textContent.trim().toLowerCase() === 'agotado') b.remove();
      });
      if (!isAvailable) {
        const badge = document.createElement('div');
        badge.className = 'product-badges__badge product-badges__badge--rectangle color-scheme-3 badge--sold-out';
        badge.textContent = 'Agotado';
        badgeContainer.appendChild(badge);
      }
    }

    // Hover filtrado por color de variante
    if (variantColor) {
      const color = variantColor.toLowerCase();
      const productCard = item.querySelector('product-card');

      if (productCard) {
        productCard.previewImage = function(event) {
          const slideshow = this.refs?.slideshow;
          if (!slideshow || event.pointerType !== 'mouse') return;

          this.resetVariant.cancel();

          const slides = Array.from(slideshow.refs?.slides || []);
          const colorSlides = slides.filter(function(slide) {
            const img = slide.querySelector('img');
            const alt = (img?.alt || '').toLowerCase().trim();
            return alt.includes(color);
          });

          if (colorSlides.length < 2) {
            slideshow.next(undefined, { animate: false });
            return;
          }

          const hoverSlide = colorSlides[1];
          if (hoverSlide) {
            const nextId = hoverSlide.getAttribute('slide-id');
            slideshow.select({ id: nextId }, undefined, { animate: false });
          }
        };
      }
    }
  }

  function waitForProductCard(item) {
    const productCard = item.querySelector('product-card');
    if (!productCard) return;

    // Si ya está definido e inicializado
    if (customElements.get('product-card') && productCard.refs) {
      applyVariantCard(item);
      return;
    }

    // Esperar a que el componente esté definido y luego a que se inicialice
    customElements.whenDefined('product-card').then(function() {
      // Pequeño delay para que refs estén disponibles
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          applyVariantCard(item);
        });
      });
    });
  }

  function getActiveColorFilter() {
    const params = new URLSearchParams(window.location.search);
    const colorParam = params.get('filter.v.t.shopify.color-pattern');
    if (!colorParam) return null;
    const id = colorParam.split('/').pop();
    return COLOR_FILTER_MAP[id] || null;
  }

  function applyColorFilter() {
    const allowedColors = getActiveColorFilter();
    if (!allowedColors) return;

    document.querySelectorAll('.product-grid__item[data-variant-color]').forEach(function(item) {
      const itemColor = item.dataset.variantColor;
      if (!allowedColors.includes(itemColor)) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Aplicar al cargar la página
    document.querySelectorAll('.product-grid__item[data-variant-id]').forEach(waitForProductCard);
    applyColorFilter();

    // Observar cambios en el grid
    const grid = document.querySelector('[ref="grid"]');
    if (grid) {
      let morphTimeout = null;
      const observer = new MutationObserver(function() {
        clearTimeout(morphTimeout);
        morphTimeout = setTimeout(function() {
          document.querySelectorAll('.product-grid__item[data-variant-id]').forEach(waitForProductCard);
          applyColorFilter();
        }, 300);
      });

      observer.observe(grid, { childList: true, subtree: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
